import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import { ReturnDisposalDetailState } from '@root/state/reducers/return_disposal/returnDisposalReducer';
import { Form, Spin } from 'antd';
import DetailsProductForm from '../../Shared/Form/DetailsProductForm';
import ProgressForm from '../components/ProgressForm';
import RecipientForm from '../components/RecipientForm';
import returnDisposalService from '@modules/Warehouse/Return/Service/returnDisposal';

interface ReturnStockPageProps {
  canEdit?: boolean;
  doneEdit?: () => void;
  commentId?: number;
}
const ReturnStockPage = ({canEdit, doneEdit, commentId}: ReturnStockPageProps) => {
  const { detailData, detailLoading } =
    useTypedSelector<ReturnDisposalDetailState>(
      (state) => state.returnDisposalDetailReducer
    );
  // products
  const products = detailData?.data?.products;
  const [formRecipient] = Form.useForm();

  const save = async () => {
    if (doneEdit && commentId) {
      await returnDisposalService.updateReturn([], formRecipient.getFieldsValue(), commentId, detailData.data.id);
      doneEdit();
    }
  }

  return (
    <Spin spinning={detailLoading} className="loading-forgot">
      <div
        style={{
          background: 'white',
          padding: '20px',
          margin: '20px',
          marginBottom: 0,
        }}
      >
        {detailData?.data?.status && (
          <div>
            <p
              style={{
                marginBottom: '0px',
                fontWeight: 'bold',
                fontSize: '15px',
                width: '150px',
                marginLeft: 'auto',
                display: 'block',
                borderRadius: '20px',
                padding: '6px 0px',
                background: '#2B2C51',
                color: 'white',
                textAlign: 'center'
              }}
            >
              {detailData?.data?.status}
            </p>
          </div>
        )}
        {
          canEdit &&
          <div>
            <p
              style={{
                marginBottom: '0px',
                fontWeight: 'bold',
                fontSize: '15px',
                width: 'max-content',
                height: '30px',
                marginLeft: 'auto',
                display: 'block',
                padding: '6px 0px',
                color: 'black',
                textAlign: 'center',
                borderBottom: '1px solid black',
                cursor: 'pointer',
                marginTop: '20px'
              }}
              onClick={() => save()}
            >
              Save
            </p>
          </div>
        }
        <DetailsProductForm data={products} edit={false} />

        <div style={{ padding: '10px 30px' }} className="orderForm">
          <RecipientForm
            form={formRecipient}
            detailData={detailData?.data}
            edit={canEdit}
            returnQuantityStock={detailData?.data?.quantity}
          />
        </div>
        {
          !canEdit &&
          <div style={{ padding: '10px 30px' }}>
            <ProgressForm
              detailData={{
                ...detailData?.data,
                deliveryStatus: detailData?.data?.returnStatus
              }}
            />
          </div>
        }
      </div>
    </Spin>
  );
}

export default ReturnStockPage;
